import React from 'react'
import { Box, Text, Avatar, Card, CardBody } from 'grommet'
import { SecondaryText } from 'web-components'
import { useDispatch, useSelector } from 'react-redux'
import DateTimeUtils from 'galarm-shared/src/utils/DateTimeUtils'
import CalendarUtilsWithExtras from 'galarm-shared/src/utils/CalendarUtilsWithExtras'
import BigText from './BigText'
import { ActionCreators, AlarmUtils } from 'galarm-shared'
import moment from 'moment-timezone'
import { I18n } from 'galarm-config'
import TintedImage from './TintedImage'

const CalendarEventSummary = props => {
  const {
    id,
    summary,
    start,
    recurrence,
    connectedAccountId,
    lastSnoozeOn,
    lastSnoozeFor,
    isCalendarView
  } = props
  const dispatch = useDispatch()
  const connectedAccounts = useSelector(
    state => state.userInfo.connectedAccounts
  )
  let profilePicForAccount = null
  if (connectedAccounts && connectedAccountId) {
    const connectedAccountForEvent = connectedAccounts.find(
      account => account.id === connectedAccountId
    )
    profilePicForAccount = connectedAccountForEvent?.user?.photo || null
  }

  const eventInSnooze =
    CalendarUtilsWithExtras.isLastSnoozeTimeInSnoozeDuration(
      lastSnoozeOn,
      lastSnoozeFor
    )

  // Get next event date, or previous if snoozed or a one time event
  const timezone = start?.timeZone || 'UTC'
  const eventDate = AlarmUtils.getCalendarEventDate(start, timezone)

  // If not recurring, just use the event date
  // If recurring and in snooze, get previous occurrence
  // If recurring and not in snooze, get next occurrence
  const nextEventDate =
    !recurrence || recurrence.length === 0
      ? eventDate
      : eventInSnooze
      ? DateTimeUtils.getPrevOccurrenceForCalendarEvent(props)
      : DateTimeUtils.getNextOccurrenceForCalendarEvent(props)

  // Validate nextEventDate before using it
  const validNextEventDate =
    nextEventDate && moment(nextEventDate).isValid()
      ? nextEventDate
      : Date.now()

  const timeString = DateTimeUtils.getLocalizedTimeAsString(
    moment(validNextEventDate).valueOf()
  )

  const dateString =
    DateTimeUtils.getLocalizedDayDateWithYearForLaterDatesAsString(
      moment(validNextEventDate).valueOf()
    )

  const snoozeTime = props.lastSnoozeOn + props.lastSnoozeFor || Date.now()
  const snoozeTimeString = DateTimeUtils.isDateToday(snoozeTime)
    ? DateTimeUtils.getLocalizedTimeAsString(snoozeTime)
    : DateTimeUtils.getLocalizedDateTimeWoYearAsString(snoozeTime)

  const repeatString = DateTimeUtils.getRepetitionStringForCalendarEvent(props)

  const handleClick = () => {
    dispatch(ActionCreators.showCalendarEventDetailsScreen(id))
  }

  return (
    <Card onClick={handleClick} background="textBackgroundColor">
      <CardBody direction="row" pad="small" justify="between">
        <Box direction="column" flex={true}>
          <Text color="textColor" truncate>
            {summary}
          </Text>
          <Box direction="row" gap="xsmall">
            <BigText color="textColor">{timeString}</BigText>
            {isCalendarView && (
              <Text alignSelf="end" color="textColor">
                {' ' + dateString}
              </Text>
            )}
          </Box>
          <Text color="textColor">{repeatString}</Text>
          {eventInSnooze && (
            <Box direction="row" justify="end" gap="xsmall">
              <SecondaryText align="center" margin={{ top: 'xsmall' }}>
                {I18n.t('snoozing', { timeString: snoozeTimeString })}
              </SecondaryText>
              <TintedImage
                tintColor="darkTint"
                src={require('galarm-res/img/web/ic_snooze.svg').default}
              />
            </Box>
          )}
        </Box>
        {profilePicForAccount && (
          <Box alignSelf="start" margin="xsmall">
            <Avatar src={profilePicForAccount} size="small" />
          </Box>
        )}
      </CardBody>
    </Card>
  )
}
export default CalendarEventSummary
